(function (angular) {

    angular.module("kv").directive('castToBoolean', function () {
        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function (value) {
                    return value? 1: 0;
                });
                ngModel.$formatters.push(function (value) {
                    // console.log("value to conevrt", value);
                    if (!value) return false;
                    if (value === true || value === false) return value;
                    else if (angular.isNumber(value)) return value===1;
                    else return parseInt(value) === 1 || value.toLowerCase()=== 'true';
                });
            }
        };
    });
})(angular);
